<template>
  <!-- <div
    class="font-bold cursor-pointer"
    @click="toggleVisibility"
    :class="isShadow ? 'bg-white w-full shadow-lg my-1 rounded-lg px-2' : 'border-b border-blue-700'"
  >
    <div
      class="flex text-xs laptop:text-base py-6 items-center ps-0 fill-blue-700"
    >
      <IconArrowDown
        class="w-3 laptop:w-6 me-1 stroke-blue-500 "
        :class="isOpen ? '' : 'rotate-90'"
        v-if="isShadow"
      />
      <IconTriangle
        class="w-3 laptop:w-6 me-1"
        :class="isOpen ? '-rotate-90' : ''"
        v-else
      />
      {{ item.title }}
    </div>
    <template v-if="item.textLink">
      <div
        v-show="isOpen"
        class="text-blue-700 opacity-70 text-start text-xs laptop:text-sm mb-9 px-8 text-justify"
      >
        {{ item.text }}
        <NuxtLink
          :to="item.url"
          class="text-blue-450 opacity-70 cursor-pointer"
        >
          {{ item.textLink }}
        </NuxtLink>
        {{ item.text2 }}
      </div>
    </template>
    <template v-else>
      <div
        v-show="isOpen"
        class="text-blue-700 opacity-70 text-start text-xs laptop:text-sm pb-9 px-8 text-justify"
      >
        {{ item.text }}
      </div>
    </template>
  </div> -->

  <div
    class="cursor-pointer"
    :class="
      isShadow
        ? 'bg-white w-full shadow-[0px_4px_4px_0px_#00000040] my-2 rounded-lg px-2'
        : 'border-b border-blue-700'
    "
  >
    <div class="flex text-xs laptop:text-base py-6 ps-0 fill-blue-700">
      <button
        class="flex w-full font-semibold"
        @click.prevent="isOpen = !isOpen"
        :aria-expanded="isOpen"
      >
        <div
          v-if="isShadow"
          class="flex text-xs laptop:text-base items-center ps-0 fill-blue-700 mt-2"
        >
          <IconArrowDown
            class="w-3 laptop:w-6 me-1 stroke-blue-500"
            :class="isOpen ? '' : 'rotate-90'"
          />
        </div>
        <IconTriangle
          v-else
          class="w-3 laptop:w-6 mt-1 ml-2 laptop:ml-0"
          :class="isOpen ? '-rotate-90' : ''"
        />
        <div class="text-start">
          <div v-html="item.title" />
          <br v-if="item.br" class="just-desktop" />
        </div>
      </button>
    </div>
    <div
      class="grid font-bold text-sm text-slate-600 overflow-hidden transition-all duration-300 ease-in-out"
      :class="
        isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
      "
    >
      <div class="overflow-hidden">
        <p
          class="text-blue-700 opacity-70 text-start text-xs laptop:text-sm mb-9 px-8 text-justify"
        >
          {{ item.text }}
        </p>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  item: Object,
  isShadow: Boolean,
});
const isOpen = ref(false);
const toggleVisibility = () => {
  isOpen.value = !isOpen.value;
};
</script>
